import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  Grid,
  AppBar,
  Tabs,
  Tab,
  Typography,
  Box,
  CircularProgress,
  Card,
  Switch,
  CardHeader,
  CardActions,
  TextField,
  MenuItem,
  Button
} from '@material-ui/core';
import { Autocomplete, createFilterOptions } from '@material-ui/lab';
import AMLDashboard from './AMLDashboard';
import FraudDashboard from './FraudDashboard';
import RecommendedAH from './RecommendedAH.js';
import FraudFilters from './FraudFilters';
import AssociationAH from './AssociationAH';
//import { NeoGraph } from './NeoGraph';
import LaunchIcon from '@material-ui/icons/Launch';
import {
  AmlGlobalMap,
  AmlIndividualMap,
  FraudGlobalMap,
  FraudIndividualMap,
  AmlAssociationMap,
  Dashboards
} from '../../common/Constants';
import ScoreDialog from './ScoreDialog';
import BloomEmbed from './BloomEmbed';
import axios from 'axios';
import { getDynamicConfigValue } from '../../dynamicConfig';
import { getKeymakerApiKey } from '../../graphql/keymakerApiKey';
import CircularPayment from './CircularPayment';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}>
      {value === index && <Box p={2}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`
  };
}
const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  },
  input: {
    marginBottom: theme.spacing(4),
    marginRight: theme.spacing(2)
  },
  recommendation: {
    marginBottom: theme.spacing(1)
  },
  details: {
    minHeight: 65,
    mariginBottom: theme.spacing(2),
    mariginLeft: theme.spacing(2)
  },
  load: {
    mariginLeft: theme.spacing(6)
  },
  visualization: {
    mariginTop: theme.spacing(2)
  },
  accountID: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(2),
    width: 150
  },
  accountName: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(2),
    width: 150
  },
  hops: {
    marginRight: theme.spacing(2)
  },
  text: {
    marginTop: theme.spacing(2)
  },
  switch: {
    marginTop: theme.spacing(1)
  },
  mode: {
    marginBottom: theme.spacing(4),
    width: '100%'
  },
  associationCard: {
    margin: theme.spacing(1),
    width: '100%',
    backgroundColor: '#2979ff',
    color: '#ffffff'
  },
  cardAction: {
    alignItems: 'right',
    justifyContent: 'flex-end'
  }
}));
var currentID = null;
var phaseParameters = {};
var phaseIdMap = {};
var alternatePhaseIdMap = {};

const Dashboard = props => {
  const [mode, setMode] = React.useState(
    localStorage.getItem('mode') === null ||
      localStorage.getItem('mode') === 'false'
      ? false
      : true
  );
  const suggestList = [
    { key: 76676, value: 'Huntington Station RV Sales' },
    { key: 89288, value: 'Arlington Heights Real Estate' },
    { key: 58589, value: 'Shamrock Trading Corporation' },
    { key: 63104, value: 'Fountain Valley Casino' },
    { key: 81839, value: 'Rancho Cordova RV Sales' },
    { key: 57619, value: 'Steel Service Oil Field Tubular, Inc.' },
    { key: 100937, value: 'West Lafayette Importers' },
    { key: 58846, value: 'Bonita Community Health Center, Inc.' },
    { key: 48942, value: 'Crier, Brnaby' },
    { key: 18813, value: 'Tomasi, Cecilius' }
  ];
  const [accountID, setAccountID] = React.useState('');
  const [accountName, setAccountName] = React.useState('');
  const [searchID, setSearchID] = React.useState([]);
  const [searchName, setSearchName] = React.useState(suggestList);
  useEffect(() => {
    if (props.location.info !== undefined) {
      setAccountID(props.location.info.customerID);
      setAccountName(props.location.info.customerName);
    }
  }, [props, setAccountID, setAccountName]);

  const classes = useStyles();
  const [recommendation, setRecommendation] = React.useState();
  const [loading, setLoading] = React.useState(false);
  const [ALoad, setALoad] = React.useState(false);
  const [accountHolderR, setAccountHolderR] = React.useState({});
  const [accountHolderA, setAccountHolderA] = React.useState({});
  const [tabR, setTabR] = React.useState(0);
  const [tabA, setTabA] = React.useState(0);
  const [selectedCard, setSelectedCard] = React.useState();
  const [associationCard, setAssociationCard] = React.useState();
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [details, setDetails] = React.useState({});
  const user = JSON.parse(localStorage.getItem('User'));
  const [hops, setHops] = React.useState(2);
  const [association, setAssociation] = React.useState();
  const hopsCount = [1, 2, 3, 4, 5];
  //const [visQueryR, setVisQueryR] = React.useState();
  //const [visQueryA, setVisQueryA] = React.useState();
  const [baseAccount, setBaseAccount] = React.useState('');

  const getAccount = async (input, param, engineID) => {
    // const keymakerApiKey = getDynamicConfigValue('REACT_APP_KEYMAKER_API_KEY');
    const keymakerApiKey = getKeymakerApiKey();

    const res = await axios
      .post(
        getDynamicConfigValue('REACT_APP_RECOMMENDATION_URI'),
        {
          query: `
              query {
                recommendations(
                  parallel: ${false}
                  engineID: "${engineID}"
                  params:{ ${param}: "${input}" }
                  first: 10000
                  skip: 0
                ) {
                  item
                  score
                  details
                }
              }
            `
        },
        {
          headers: {
            'api-key': keymakerApiKey
          }
        }
      )
      .catch(err => console.log(err));
    return res.data ? res.data.data.recommendations : [];
  };

  const handleIDSearch = async event => {
    const data = await getAccount(
      event.target.value,
      'customerID',
      'fraud-account-search'
    );
    setSearchID(
      data.map(s => {
        return { value: s.item.accountName, key: s.item.accountHolderID };
      })
    );
  };

  const handleNameSearch = async event => {
    // setAccountName(event.target.value);
    // setAccountID(event.target.value);
    const data = await getAccount(
      event.target.value,
      'customerName',
      'aml-account-name-search'
    );

    setSearchName(
      data.map(s => {
        //console.log(s.item);
        return { value: s.item.accountName, key: s.item.accountHolderID };
      })
    );
  };

  const handlehopChange = event => {
    setHops(event.target.value);
  };

  const handleModeChange = () => {
    setMode(!mode);
    setRecommendation();
    setAssociation();
    setAccountID('');
    // window.location.reload(false);
    localStorage.setItem('mode', !mode);
    //handleSetPages(!mode)
    phaseIdMap = {};
    alternatePhaseIdMap = {};
  };

  if (currentID !== props.match.params.id) {
    setRecommendation();
    setAccountID('');
    setSearchName(suggestList);
    currentID = props.match.params.id;
    phaseIdMap = {};
    alternatePhaseIdMap = {};
  }
  const handleChangeTabR = (event, newValue) => {
    setTabR(newValue);
  };
  const handleChangeTabA = (event, newValue) => {
    setTabA(newValue);
  };

  const handleChangeIndexTabR = index => {
    setTabR(index);
  };
  const handleChangeIndexTabA = index => {
    setTabA(index);
  };
  const handleLoading = load => {
    setLoading(load);
  };
  const filterCallback = recommendation => {
    handleChangeIndexTabA(0);
    handleChangeIndexTabR(0);
    if (recommendation !== undefined) {
      setRecommendation(recommendation);
    } else {
      setRecommendation();
    }
  };
  const RHCallback = item => {
    handleChangeIndexTabR(1);
    setAccountHolderR(item);
  };
  const AHCallback = item => {
    handleChangeIndexTabA(1);
    setAccountHolderA(item);
  };
  const handleSetAccountHolder = val => {
    setAccountHolderR(val);
    setAccountHolderA(val);
  };

  const handleChangeAccount = event => {
    setAccountID(event.target.value);
  };

  const displayAccountID = () => {
    if (mode) {
      return (
        <Grid container item xs={8}>
          {/* <Autocomplete
            className={classes.accountID}
            onOpen={handleIDSearch}
            disableClearable
            getOptionSelected={(option, value) => value === option}
            getOptionLabel={option => (option.key ? option.key.toString() : '')}
            options={searchID ? searchID : []}
            // value={{ key: accountID, value: accountName }}
            value={
              accountID !== '' ? { key: accountID, value: accountName } : null
            }
            onChange={(event, newValue) => {
              setAccountID(newValue.key);
              setAccountName(newValue.value);
            }}
            renderInput={params => (
              <TextField
                {...params}
                InputProps={{
                  ...params.InputProps
                }}
                label="Account ID"
                variant="outlined"
                color="secondary"

                //onChange={handleChangeAccount}
              />
            )}
          /> */}

          <Autocomplete
            className={classes.accountName}
            style={{ width: 300 }}
            filterOptions={createFilterOptions({ limt: 100 })}
            //onOpen={handleNameSearch}
            value={
              accountID !== '' ? { key: accountID, value: accountName } : null
            }
            getOptionSelected={(option, value) =>
              value === option.value || value.value === option.value
            }
            getOptionLabel={option =>
              option.value
                ? option.key.toString() + '--' + option.value.toString()
                : ''
            }
            options={searchName ? searchName : []}
            onChange={(event, newValue, reason) => {
              //handleNameSearch(event);
              console.log(reason);
              if (reason === 'clear') {
                setSearchName(suggestList);
                setAccountID(newValue !== null ? newValue.key : '');
                setAccountName(newValue !== null ? newValue.value : '');
              } else {
                setAccountID(newValue !== null ? newValue.key : '');
                setAccountName(newValue !== null ? newValue.value : '');
              }
            }}
            renderInput={params => (
              <TextField
                {...params}
                InputProps={{
                  ...params.InputProps,
                  form: {
                    autocomplete: 'off'
                  }
                }}
                //fullWidth={true}
                label="Account"
                variant="outlined"
                color="secondary"
                onChange={handleNameSearch}
                //onChange={handleChangeAccount}
              />
            )}
          />

          {/* <TextField
            className={classes.accountID}
            variant="outlined"
            color="secondary"
            label="Account ID"
            onChange={handleChangeAccount}
            value={accountID}
          /> */}

          {currentID === 'Credit Fraud' ||
          currentID === 'Shared PII' ||
          currentID === 'Entity Resolution' ? null : (
            <TextField
              id="select-hop"
              className={classes.hops}
              variant="outlined"
              select
              value={hops}
              onChange={handlehopChange}
              label="Hops">
              {hopsCount.map(val => (
                <MenuItem key={val} value={val}>
                  {val}
                </MenuItem>
              ))}
            </TextField>
          )}
        </Grid>
      );
    }
  };
  const displayMode = () => {
    return (
      <Grid container item xs={12}>
        <Grid container item xs={2}>
          <Typography className={classes.text} variant="h5">
            Global
          </Typography>
          <Switch
            className={classes.switch}
            checked={mode}
            onChange={handleModeChange}
            color="secondary"
            name="Global or Individual"
            inputProps={{ 'aria-label': 'primary checkbox' }}
          />{' '}
          <Typography className={classes.text} variant="h5">
            Individual
          </Typography>
        </Grid>
        {displayAccountID()}
      </Grid>
    );
  };

  const dashboardSelected = Dashboards.includes(currentID);
  let dashboardComp = <div></div>;
  if (currentID === 'AML-Dashboard') {
    dashboardComp = (
      <AMLDashboard
        value={tabR}
        handleChange={handleChangeTabR}
        a11yProps={a11yProps}
        TabPanel={TabPanel}
        setMode={setMode}
      />
    );
  } else if (currentID === 'Fraud-Dashboard') {
    dashboardComp = (
      <FraudDashboard
        value={tabR}
        handleChange={handleChangeTabR}
        a11yProps={a11yProps}
        TabPanel={TabPanel}
        setMode={setMode}
      />
    );
  } else if (currentID === 'Circular-Payment') {
    dashboardComp = (
      <CircularPayment
        value={tabR}
        handleChange={handleChangeTabR}
        a11yProps={a11yProps}
        TabPanel={TabPanel}
        setMode={setMode}
      />
    );
  }

  return (
    <div className={classes.root}>
      {!dashboardSelected ? (
        <Grid item container xs={12}>
          <Card className={classes.mode}>
            <CardHeader title={displayMode()} />
          </Card>
        </Grid>
      ) : (
        <div />
      )}
      {!dashboardSelected ? (
        <Grid item container className={classes.input} xs={12}>
          <FraudFilters
            id={
              mode === false
                ? AmlGlobalMap.get(props.match.params.id) !== undefined
                  ? AmlGlobalMap.get(props.match.params.id)
                  : FraudGlobalMap.get(props.match.params.id)
                : AmlIndividualMap.get(props.match.params.id) !== undefined
                ? AmlIndividualMap.get(props.match.params.id)
                : FraudIndividualMap.get(props.match.params.id)
            }
            drillEngine={
              mode === undefined || mode === false
                ? null
                : AmlAssociationMap.get(props.match.params.id)
            }
            setSelectedCard={setSelectedCard}
            setAccountHolder={handleSetAccountHolder}
            parentCallback={filterCallback}
            loadCallback={handleLoading}
            phaseParameters={phaseParameters}
            accountID={accountID}
            setAssociation={setAssociation}
            phaseIdMap={phaseIdMap}
            currentID={currentID}
            alternatePhaseIdMap={alternatePhaseIdMap}
            mode={mode}
          />
        </Grid>
      ) : (
        <div />
      )}
      {loading === true ? (
        <Grid item className={classes.load} xs={12}>
          <CircularProgress color="secondary" />
        </Grid>
      ) : (
        <div />
      )}
      {dashboardSelected ? (
        dashboardComp
      ) : recommendation !== undefined ? (
        recommendation.data.recommendations !== null ? (
          recommendation.data.recommendations.length !== 0 ? (
            <div>
              <Card>
                <AppBar position="static" color="secondary">
                  <Tabs
                    value={tabR}
                    onChange={handleChangeTabR}
                    TabIndicatorProps={{
                      style: {
                        backgroundColor: '#FFFFFF',
                        height: 3.9
                      }
                    }}
                    variant="fullWidth">
                    <Tab
                      label="Result"
                      {...a11yProps(0)}
                      style={{ fontSize: 17 }}
                    />
                    <Tab
                      label="Visualization"
                      {...a11yProps(1)}
                      style={{ fontSize: 17 }}
                    />
                  </Tabs>
                </AppBar>
                <TabPanel value={tabR} index={0}>
                  <Grid
                    container
                    className={classes.recommendation}
                    item
                    xs={12}>
                    <RecommendedAH
                      id={props.match.params.id}
                      recommendation={recommendation}
                      AHCallback={RHCallback}
                      setSelectedCard={setSelectedCard}
                      selectedCard={selectedCard}
                      handleOpen={setDialogOpen}
                      setDetails={setDetails}
                      setOtherCard={setAssociationCard}
                      setAssociation={setAssociation}
                      //setVisQuery={setVisQueryR}
                      setALoad={setALoad}
                      hops={hops}
                      setBaseAccount={setBaseAccount}
                      alternatePhaseIdMap={alternatePhaseIdMap}
                    />
                  </Grid>
                  {ALoad === true ? (
                    <Grid item className={classes.load} xs={12}>
                      <CircularProgress color="secondary" />
                    </Grid>
                  ) : (
                    <div />
                  )}
                  {association !== undefined ? (
                    association.data.recommendations !== null ? (
                      association.data.recommendations.length !== 0 ? (
                        <Card>
                          <Grid
                            container
                            justify="center"
                            item
                            xs={12}
                            className={classes.recommendation}>
                            <AppBar position="static" color="secondary">
                              <Tabs
                                value={tabA}
                                onChange={handleChangeTabA}
                                TabIndicatorProps={{
                                  style: {
                                    backgroundColor: '#FFFFFF',
                                    height: 3.9
                                  }
                                }}
                                variant="fullWidth">
                                <Tab
                                  label="Association"
                                  {...a11yProps(0)}
                                  style={{ fontSize: 17 }}
                                />
                                <Tab
                                  label="Visualization"
                                  {...a11yProps(1)}
                                  style={{ fontSize: 17 }}
                                />
                              </Tabs>
                            </AppBar>
                            <TabPanel value={tabA} index={0}>
                              <Grid
                                container
                                item
                                className={classes.recommendation}
                                xs={12}>
                                <AssociationAH
                                  recommendation={association}
                                  AHCallback={AHCallback}
                                  setOtherCard={setSelectedCard}
                                  setSelectedCard={setAssociationCard}
                                  selectedCard={associationCard}
                                  handleOpen={setDialogOpen}
                                  setDetails={setDetails}
                                  //setVisQuery={setVisQueryA}
                                  userID={baseAccount}
                                />
                              </Grid>
                            </TabPanel>
                            <TabPanel value={tabA} index={1}>
                              {accountHolderA.accountHolderID !== undefined ? (
                                <div>
                                  <Grid
                                    container
                                    item
                                    xs={12}
                                    className={classes.details}
                                    spacing={2}>
                                    <Grid item xs={5}>
                                      <Typography
                                        align="center"
                                        color="secondary"
                                        variant="h4">
                                        {accountHolderA.accountName}{' '}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={5}>
                                      <Typography align="center" variant="h5">
                                        {' '}
                                        AccountHolderID:
                                        {accountHolderA.accountHolderID}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                      <Button
                                        color="secondary"
                                        variant="outlined"
                                        onClick={() => {
                                          window.open(
                                            process.env.REACT_APP_BLOOM +
                                              `${process.env.REACT_APP_BLOOM_URL_OPERATOR}search=Application Scenario for ${accountHolderA.accountHolderID}&perspective=${user.email} Perspective&run=true`,
                                            '_blank'
                                          );
                                        }}>
                                        <LaunchIcon />
                                      </Button>
                                    </Grid>
                                  </Grid>
                                  <Grid
                                    container
                                    justify="center"
                                    item
                                    xs={12}
                                    className={classes.visualization}>
                                    {/* <NeoGraph
                                      width={1200}
                                      height={600}
                                      containerId={'id2'}
                                      neo4jUri={process.env.REACT_APP_NEO4J_URI}
                                      neo4jUser={
                                        process.env.REACT_APP_NEO4J_USER
                                      }
                                      neo4jPassword={
                                        process.env.REACT_APP_NEO4J_PASSWORD
                                      }
                                      userId={accountHolderA.accountHolderID}
                                      backgroundColor={'#F5FCFF'}
                                      initialCypher={
                                        visQueryA !== undefined
                                          ? visQueryA
                                          : `MATCH p= (cu:AccountHolder{accountHolderID:${accountHolderA.accountHolderID}}) RETURN p`
                                      }
                                    /> */}
                                    <BloomEmbed
                                      width="1300"
                                      bloomURL={
                                        process.env.REACT_APP_BLOOM +
                                        `${process.env.REACT_APP_BLOOM_URL_OPERATOR}search=Application Scenario for ${accountHolderA.accountHolderID}&perspective=${user.email} Perspective&run=true`
                                      }
                                    />
                                  </Grid>
                                </div>
                              ) : (
                                <div />
                              )}
                            </TabPanel>
                          </Grid>
                        </Card>
                      ) : (
                        <div />
                      )
                    ) : (
                      <div />
                    )
                  ) : (
                    <div />
                  )}

                  <ScoreDialog
                    open={dialogOpen}
                    onClose={() => {
                      setDialogOpen(false);
                    }}
                    setSelectedCard={setSelectedCard}
                    setAssociationCard={setAssociationCard}
                    details={details}
                  />

                  <CardActions className={classes.cardAction}>
                    {recommendation !== undefined ? (
                      recommendation.data.recommendations !== null ? (
                        recommendation.data.recommendations.length > 1 ? (
                          <Typography>
                            Displaying top{' '}
                            {recommendation.data.recommendations.length} results
                          </Typography>
                        ) : association !== undefined ? (
                          association.data.recommendations !== null ? (
                            association.data.recommendations.length !== 0 ? (
                              <Typography>
                                Displaying top{' '}
                                {association.data.recommendations.length}{' '}
                                associations
                              </Typography>
                            ) : (
                              <div />
                            )
                          ) : (
                            <div />
                          )
                        ) : (
                          <div />
                        )
                      ) : (
                        <div />
                      )
                    ) : (
                      <div />
                    )}
                  </CardActions>
                </TabPanel>
                <TabPanel value={tabR} index={1}>
                  {accountHolderR.accountHolderID !== undefined ? (
                    <div>
                      <Grid
                        container
                        item
                        xs={12}
                        className={classes.details}
                        spacing={2}>
                        <Grid item xs={5}>
                          <Typography
                            align="center"
                            color="secondary"
                            variant="h4">
                            {accountHolderR.accountName}{' '}
                          </Typography>
                        </Grid>
                        <Grid item xs={5}>
                          <Typography align="center" variant="h5">
                            {' '}
                            AccountHolderID:{accountHolderR.accountHolderID}
                          </Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <Button
                            color="secondary"
                            variant="outlined"
                            onClick={() => {
                              console.log(accountHolderR.accountHolderID);
                              window.open(
                                process.env.REACT_APP_BLOOM +
                                  `${process.env.REACT_APP_BLOOM_URL_OPERATOR}search=Application Scenario for ${accountHolderR.accountHolderID}&perspective=${user.email} Perspective&run=true`,
                                '_blank'
                              );
                            }}>
                            <LaunchIcon />
                          </Button>
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        justify="center"
                        item
                        xs={12}
                        className={classes.visualization}>
                        {/* <NeoGraph
                          width={1200}
                          height={600}
                          containerId={'id1'}
                          neo4jUri={process.env.REACT_APP_NEO4J_URI}
                          neo4jUser={process.env.REACT_APP_NEO4J_USER}
                          neo4jPassword={process.env.REACT_APP_NEO4J_PASSWORD}
                          userId={accountHolderR.accountHolderID}
                          backgroundColor={'#F5FCFF'}
                          initialCypher={
                            visQueryR !== undefined
                              ? visQueryR
                              : `MATCH p= (cu:AccountHolder{accountHolderID:${accountHolderR.accountHolderID}}) RETURN p`
                          }
                        /> */}
                        <BloomEmbed
                          width="1500"
                          bloomURL={
                            process.env.REACT_APP_BLOOM +
                            `${process.env.REACT_APP_BLOOM_URL_OPERATOR}search=Application Scenario for ${accountHolderR.accountHolderID}&perspective=${user.email} Perspective&run=true`
                          }
                        />
                      </Grid>
                    </div>
                  ) : (
                    <div />
                  )}
                </TabPanel>
              </Card>
            </div>
          ) : (
            <div />
          )
        ) : (
          <div />
        )
      ) : (
        <div />
      )}
    </div>
  );
};

export default Dashboard;
